import * as axios from 'axios';

export const CLEAR_CLIENT = '/client/clear_client';
export const CLEAR_NEW_CHILD = '/client/clear_new_child';
export const SET_NEW_CLIENT = '/client/set_new_client';
export const SET_CLIENT_NOT_FOUND = '/client/set_client_not_found';
export const SET_HAS_SERVICES_FOR_CLIENT =
  '/client/set_has_services_for_client';
export const SET_HAS_CHILDREN = '/client/set_has_children';
export const SET_CLIENT_VARIATION = './client/set_client_variation';
export const SET_CLIENT_INFORMATION = './client/set_client_information';
export const SET_CLIENT_CHILD_INFORMATION =
  './client/set_client_child_information';
export const SET_CLIENT_SAVE_ERROR = './client/set_client_save_error';
export const SET_CHILD_SELECTED_FOR_SERVICE =
  './client/set_child_selected_for_service';
export const CLEAR_CLIENT_EMPLOYEE = './client/clear_client_employee'
export const SET_CLIENT_EMPLOYEE = './client/set_client_employee';
export const UPDATE_CLIENT_EMPLOYEE_ESTIMATIONS = './client/update_client_employee_estimations';

export function setNewClient(isNewClient) {
  return { type: SET_NEW_CLIENT, data: isNewClient };
}

export function setClientNotFound(isNotFound) {
  return { type: SET_CLIENT_NOT_FOUND, data: isNotFound };
}

export function clearClient() {
  return { type: CLEAR_CLIENT };
}

export function clearNewChild() {
  return { type: CLEAR_NEW_CHILD };
}

export function setHasServicesForClient(hasServicesForClient) {
  return {
    type: SET_HAS_SERVICES_FOR_CLIENT,
    data: hasServicesForClient,
  };
}

export function setHasChildren(hasChildren, hasServicesForClient) {
  return {
    type: SET_HAS_CHILDREN,
    data: { hasChildren, hasServicesForClient },
  };
}

export function selectChildForServices(childId, selected) {
  return {
    type: SET_CHILD_SELECTED_FOR_SERVICE,
    data: {
      childId,
      selected,
    },
  };
}

export function setClientVariation(
  clientId,
  childId,
  variationId,
  parentVariationId,
  selected
) {
  return {
    type: SET_CLIENT_VARIATION,
    data: { clientId, childId, variationId, parentVariationId, selected },
  };
}

export function clearClientEmployee() {
  return {
    type: CLEAR_CLIENT_EMPLOYEE,
  }
}

export function setClientEmployee(clientId, childId, employeeId, estimation) {
  return {
    type: SET_CLIENT_EMPLOYEE,
    data: { clientId, childId, employeeId, estimation },
  };
}

export function updateClientEmployeeEstimations(estimations) {
  return {
    type: UPDATE_CLIENT_EMPLOYEE_ESTIMATIONS,
    data: { estimations },
  }
}

export function setClientInformation(clientInformation) {
  return {
    type: SET_CLIENT_INFORMATION,
    data: clientInformation,
  };
}

export function setClientChildInformation(childInformation, childIndex) {
  return {
    type: SET_CLIENT_CHILD_INFORMATION,
    data: { childInformation, childIndex },
  };
}

// transforms the intake form format to backend format
function transformCustomFieldValues(cfv) {
  if (cfv) {
    return Object.keys(cfv).map(id => ({
      custom_field_id: id,
      required: false,
      value: cfv[id],
    }));
  }

  return [];
}

// transforms the backend format to input form format
function transformIntoCustomFieldValues(cfv) {
  const customFieldValues = {};

  if (cfv) {
    cfv.forEach(cf => {
      if (cf.value && cf.value.toString().indexOf('T') > -1)
        customFieldValues[cf.custom_field_id] = cf.value;
      // date
      // turn "1" into 1
      else
        customFieldValues[cf.custom_field_id] = isNaN(parseInt(cf.value, 10))
          ? cf.value
          : parseInt(cf.value, 10);
    });
  }

  return customFieldValues;
}

function getAddress(customFieldValues) {
  let address = undefined;
  customFieldValues.forEach(cfv => {
    if (cfv.value != null && cfv.value.country != null) address = cfv.value;
  });
  return address;
}

function getClientCreateData(clientInformation, includeChildren = true) {
  const customFieldValues = transformCustomFieldValues(
    clientInformation.custom_field_values
  );

  const childCustomFieldValues = transformCustomFieldValues(
    clientInformation.children[0].custom_field_values
  );

  const data = {
    from_kiosk: true,
    client: {
      //...clientInformation,

      email: clientInformation.email,
      first_name: clientInformation.first_name,
      id: clientInformation.id,
      last_name: clientInformation.last_name,
      mobile_phone: clientInformation.mobile_phone,
      date_of_birth: clientInformation.date_of_birth,
      preferred_language: clientInformation.preferred_language,
      gender:
        clientInformation.gender === 2147483647
          ? 2
          : clientInformation.gender === 2147483646
          ? 1
          : undefined,
      can_receive_automated_emails:
        clientInformation.can_receive_automated_emails,
      can_receive_automated_sms: clientInformation.can_receive_automated_sms,
      can_receive_manual_emails: clientInformation.can_receive_manual_emails,
      can_receive_manual_sms: clientInformation.can_receive_manual_sms,

      custom_field_values: customFieldValues,
      client_since: new Date().toISOString(),
      source_quick_add: true,
      addresses: clientInformation.addresses
        ? clientInformation.addresses
        : getAddress(customFieldValues)
        ? [getAddress(customFieldValues)]
        : [],
      children: includeChildren
        ? childCustomFieldValues.length > 0
          ? [
              {
                type: translateChildTypeToBackendModel(
                  clientInformation.companyChildType
                ),
                custom_field_values: childCustomFieldValues,
              },
            ]
          : undefined
        : undefined,
    },
    addresses: true,
    client_packages: true,
    custom_variations: true,
    photo_url: true,
    note: true,
    last_appointment_details: true,
    children:
      includeChildren && childCustomFieldValues && childCustomFieldValues.length
        ? true
        : false,
    custom_field_values: true,
    for_appointment: true,
    membership_client_packages: true,
  };

  return data;
}

export function createClient(clientInformation) {
  return function(dispatch) {
    return axios
      .post(`/my_client/clients.json`, getClientCreateData(clientInformation))
      .then(res => {
        const children = getChildrenWithNames(res.data.client.children);
        // const client = { ...res.data.client, children: children };

        const client = {
          ...clientInformation,
          children: [
            {
              ...clientInformation.children[0],
            },
          ],
        };

        client.id = res.data.client.id;
        if (children && children.length > 0 && children[0].id != null) {
          client.children[0].client_id = res.data.client.id;
          client.children[0].id = children[0].id;
          client.children[0].first_name = children[0].first_name;
          client.children[0].last_name = children[0].last_name;
        }

        client.original_custom_field_values = transformIntoCustomFieldValues(
          res.data.client.custom_field_values
        );
        client.original_email = res.data.client.email;
        client.original_mobile_phone = res.data.client.mobile_phone;
        client.email = res.data.client.email;
        client.first_name = res.data.client.first_name;
        client.last_name = res.data.client.last_name;
        client.mobile_phone = res.data.client.mobile_phone;
        client.date_of_birth = res.data.client.date_of_birth;
        client.gender =
          res.data.client.gender === 2
            ? 2147483647
            : res.data.client.gender === 1
            ? 2147483646
            : res.data.client.gender;
        client.can_receive_automated_emails =
          res.data.client.can_receive_automated_emails;
        client.can_receive_automated_sms =
          res.data.client.can_receive_automated_sms;
        client.can_receive_manual_emails =
          res.data.client.can_receive_manual_emails;
        client.can_receive_manual_sms = res.data.client.can_receive_manual_sms;

        dispatch({ type: SET_CLIENT_INFORMATION, data: client });

        if (children && children.length > 0 && children[0].id) {
          dispatch(selectChildForServices(children[0].id, true));
        }

        return Promise.resolve(true);
      })
      .catch(error => {
        if (error?.response?.status === 422) {
          dispatch({
            type: SET_CLIENT_SAVE_ERROR,
            data: error.response.data.client
              ? error.response.data.client.errors
              : error.response.data.child
              ? error.response.data.child.errors
              : [],
          });
          return Promise.resolve(false);
        }

        return Promise.resolve(false);
      });
  };
}

export function updateClient(
  clientInformation,
  hasChildren,
  childrenSelectedForServices = null
) {
  return function(dispatch) {
    return axios
      .put(
        `/my_client/clients/${clientInformation.id}.json`,
        getClientCreateData(clientInformation, false)
      )
      .then(async () => {
        const promises = [];

        if (hasChildren) {
          clientInformation.children.forEach(child => {
            if (child.id) {
              if (
                !childrenSelectedForServices ||
                childrenSelectedForServices.indexOf(child.id) > -1
              ) {
                promises.push(
                  axios.put(
                    `/my_client/clients/${clientInformation.id}/children/${child.id}.json`,
                    {
                      from_kiosk: true,
                      child: {
                        id: child.id,
                        type:
                          child.type ||
                          translateChildTypeToBackendModel(
                            clientInformation.companyChildType
                          ),
                        client_id: child.client_id,
                        custom_field_values: transformCustomFieldValues(
                          child.custom_field_values
                        ),
                      },
                    }
                  )
                );
              }
            } else if (
              child &&
              !child.id &&
              child.custom_field_values &&
              Object.keys(child.custom_field_values).length > 0
            ) {
              const transformedChildCustomFieldValues = transformCustomFieldValues(
                child.custom_field_values
              );

              if (transformedChildCustomFieldValues) {
                promises.push(
                  axios.post(
                    `/my_client/clients/${clientInformation.id}/children`,
                    {
                      from_kiosk: true,
                      child: {
                        type:
                          child.type ||
                          translateChildTypeToBackendModel(
                            clientInformation.companyChildType
                          ),
                        client_id: clientInformation.id,
                        custom_field_values: transformedChildCustomFieldValues,
                      },
                    }
                  )
                );
              }
            }
          });

          await Promise.all(promises);
        }

        await dispatch(getClient(clientInformation.id));

        return Promise.resolve(true);
      })
      .catch(error => {
        if (error?.response?.status === 422) {
          dispatch({
            type: SET_CLIENT_SAVE_ERROR,
            data: error.response.data.client
              ? error.response.data.client.errors
              : error.response.data.child
              ? error.response.data.child.errors
              : [],
          });
          return Promise.resolve(false);
        }

        return Promise.resolve(false);
      });
  };
}

function translateChildTypeToBackendModel(companyChildType) {
  if (companyChildType === 'family_member') {
    return 'MyClient::Child::FamilyMember';
  } else if (companyChildType === 'pet') {
    return 'MyClient::Child::Pet';
  } else if (companyChildType === 'vehicle') {
    return 'MyClient::Child::Vehicle';
  } else {
    return null;
  }
}

export function createChild(clientId, child, companyChildType) {
  return function(dispatch) {
    return axios
      .post(`/my_client/clients/${clientId}/children`, {
        from_kiosk: true,
        child: {
          type:
            child.type || translateChildTypeToBackendModel(companyChildType),
          client_id: clientId,
          custom_field_values: transformCustomFieldValues(
            child.custom_field_values
          ),
        },
      })
      .then(async res => {
        await dispatch(getClient(clientId));
        return Promise.resolve(true);
      })
      .catch(error => {
        return Promise.resolve(false);
      });
  };
}

export function findClient(emailOrPhoneNumber) {
  return function(dispatch) {
    dispatch(clearClient());

    return axios
      .get(
        `/my_client/clients/filter.json?mcsearch=${emailOrPhoneNumber}&for_appointment=true&email_or_phone_only=true`
      )
      .then(async res => {
        if (res.data.clients && res.data.clients.length > 0) {
          await dispatch(getClient(res.data.clients[0].id));
          return Promise.resolve({ found: true, clients: res.data.clients });
        } else {
          dispatch(setNewClient(true));
          dispatch(setClientNotFound(true));
          return Promise.resolve({ found: false, clients: [] });
        }
      })
      .catch(error => {
        return Promise.resolve({ found: false, clients: [] });
      });
  };
}

export function getClient(clientId) {
  return function(dispatch, getState) {
    const params = {
      children: true,
      custom_field_values: true,
      addresses: true,
      from_kiosk: true,
      client_memberships: true,
    }

    return axios
      .get(
        `/my_client/clients/${clientId}.json`, { params }
      )
      .then(async res => {
        dispatch(setNewClient(false));

        const client = res.data.client;
        localStorage.setItem('clientId', client.id);
        client.children = getChildrenWithNames(
          client.children ? client.children : [{}]
        );

        client.original_date_of_birth = client.date_of_birth;
        client.gender =
          res.data.client.gender === 2
            ? 2147483647
            : res.data.client.gender === 1
            ? 2147483646
            : res.data.client.gender;

        client.original_gender = client.gender;

        client.original_can_receive_automated_emails =
          client.can_receive_automated_emails;
        client.original_can_receive_automated_sms =
          client.can_receive_automated_sms;
        client.original_can_receive_manual_emails =
          client.can_receive_manual_emails;
        client.original_can_receive_manual_sms = client.can_receive_manual_sms;
        client.original_email = client.email;
        client.original_mobile_phone = client.mobile_phone;

        const cfv = client.custom_field_values;
        client.custom_field_values = transformIntoCustomFieldValues(cfv);
        client.original_custom_field_values = transformIntoCustomFieldValues(
          cfv
        );

        client.children.forEach(child => {
          const ccfv = child.custom_field_values;
          child.custom_field_values = transformIntoCustomFieldValues(ccfv);
          child.original_custom_field_values = transformIntoCustomFieldValues(
            ccfv
          );
        });

        await dispatch({ type: SET_CLIENT_INFORMATION, data: client });

        return Promise.resolve(true);
      })
      .catch(error => {
        return Promise.resolve(false);
      });
  };
}

function getChildrenWithNames(children) {
  if (!children) return [{}];

  return children.map(c => {
    let firstName = c.custom_field_values.filter(
      cf => cf.uuid === 'first_name' || cf.uuid === 'pet_name'
    )[0]?.value;

    if (!firstName) {
      firstName = c.custom_field_values.filter(cf => cf.uuid === 'vehicle')[0]
        ?.value?.vehicle_make;
    }

    return {
      ...c,
      first_name: firstName,
      last_name: c.custom_field_values.filter(cf => cf.uuid === 'last_name')[0]
        ?.value,
    };
  });
}
